import React from 'react'
import PropTypes from 'prop-types'
import {Query} from 'react-apollo'
import {GET_PERSON_USER} from './graphql'
import BlockWithLoader from '../../Support/BlockWithLoader'
import UserForm from '../../People/UserForm'

const propTypes = {
  personId: PropTypes.number.isRequired
}

const UserTab = ({personId}) => {
  return (
    <Query query={GET_PERSON_USER} variables={{person_id: personId}}
      fetchPolicy='network-only' notifyOnNetworkStatusChange>
      {({data, loading, error}) => {
        if (error) return <div>An unexpected error occurred{JSON.stringify(error)}</div>

        return (
          <BlockWithLoader loading={loading} renderChildren={true}>
            {!loading &&
            <UserForm person_id={personId} editData={data.person.user}/>}
          </BlockWithLoader>
        )
      }
      }
    </Query>
  )
}

UserTab.propTypes = propTypes

export default UserTab



// WEBPACK FOOTER //
// ./src/components/Profile/tabs/UserTab.js